/**
 * Abonelik ve Kullanım domaininin BÖLÜMLERİ (D06 — CLOS-197 `[173]`).
 *
 * Kanonik bilgi mimarisi D06 altında üç sekme tanımlıyor: Genel Bakış, Kullanım ve Ek
 * Haklar, Faturalama. Kart *"D06 tek sidebar sayfasıdır"* diyor — sekmeler sidebar'a
 * ikinci bir üst düzey öğe olarak girmiyor. Kayıt `contractSections.ts` ve
 * `organizationSections.ts` ile AYNI kuralları taşıyor; yeni bir desen icat edilmedi.
 *
 * ### ⚠ BUGÜN TEK BÖLÜM KAYITLI — ve bu bilerek
 *
 * Kartın kuralı: *"henüz desteklenmeyen değer uydurulmaz"*, *"olmayan özellik aktifmiş
 * gibi gösterilmez."* Diğer iki sekmenin kaynağı henüz yazılmadı:
 *
 * - **Kullanım ve Ek Haklar** — depolama/AI sayaçları CLOS-200 `[174]`, ek haklar
 *   CLOS-201 `[175]`; ikisi de Yapılacaklar'da.
 * - **Faturalama** — CLOS-202/203, ödeme sağlayıcısı kararına bağlı.
 *
 * Boş sekme çizmek, kullanıcıya tıklayınca hiçbir şey bulamayacağı bir kapı göstermek
 * olurdu. Kayıt yapısı hazır: kartları geldiğinde her biri BİR SATIR ekleyecek.
 *
 * ⚠ Tek bölüm varken kabuk sekme çubuğunu HİÇ çizmiyor (`SubscriptionLayout`) —
 * tıklanacak tek yer varken gezinme göstermek gürültü.
 *
 * ⚠ Görünürlük bir GÜVENLİK SINIRI DEĞİL: gerçek kapı uçtaki `requirePermission`.
 *
 * ### ⚠ CLOS-202/201 İKİ SATIR EKLEDİ, ÜÇÜNCÜSÜNÜ EKLEMEDİ
 *
 * Kanonik IA "Kullanım ve Ek Haklar"ı TEK sekmede birleştiriyor. Kullanım tarafı
 * (depolama/AI sayaçları, CLOS-200) hâlâ Yapılacaklar'da; ikisini birleştirip yarısını
 * boş çizmek yerine yalnız KENDİ kartımın kapsamı olan "Ek Haklar"ı ayrı bir bölüm olarak
 * ekliyoruz. CLOS-200 geldiğinde iki bölüm birleştirilebilir ya da kanonik IA'ya
 * tam uyum için ayrı bir karar istenebilir — bu satır o kararı ÖNCEDEN vermiyor.
 */

export interface SubscriptionSection {
  key: string;
  label: string;
  route: string;
  /** Gerektiren yetki; `null` ise bölüm herkese açık. */
  permission: string | null;
}

/** ⚠ SIRA KANONİKTİR. Yeni bölüm araya değil, kartının söylediği yere girer. */
export const SUBSCRIPTION_SECTIONS: readonly SubscriptionSection[] = [
  {
    key: "overview",
    label: "Genel Bakış",
    route: "/app/abonelik",
    permission: "subscription.view",
  },
  {
    key: "addons",
    label: "Ek Haklar",
    route: "/app/abonelik/ek-haklar",
    permission: "subscription.entitlement",
  },
  {
    key: "billing",
    label: "Faturalama",
    route: "/app/abonelik/faturalama",
    permission: "subscription.invoice",
  },
];

export function visibleSubscriptionSections(
  can: (permission: string) => boolean,
  sections: readonly SubscriptionSection[] = SUBSCRIPTION_SECTIONS,
): SubscriptionSection[] {
  return sections.filter((s) => s.permission === null || can(s.permission));
}
